import { useSelector } from "react-redux";

const usePermission = () => {

  const permissions = useSelector(
    state => state.permissions?.permissions || []
  );

  if(permissions==="!"){
    return{
      permissions:[],
      hasPermission:()=>false,
      hasAllPermissions:()=>false,
    };
  }

  const hasPermission=(...requiredPermissions)=>{
    if(!requiredPermissions.length) return true;
    if(permissions.includes("*")) return true;
    return requiredPermissions.some(
      permission=>permissions.includes(permission)
    );
  };

  const hasAllPermissions=(...requiredPermissions)=>{
    if(!requiredPermissions.length) return true;
    if(permissions.includes("*")) return true;
    return requiredPermissions.every(
      permission=>permissions.includes(permission)
    );
  };

  return { permissions, hasPermission, hasAllPermissions, };
};

export default usePermission;